<template>
  <div>

    <v-card class="mb-5" v-if="pastNames.length > 0">
      <v-card-title>
        <v-toolbar-title>Account Past Names</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-list-item v-for="name of pastNames" :key="name">
          {{ name }}
        </v-list-item>
      </v-card-text>
    </v-card>

    <v-card class="mb-5">
      <v-card-title>
        <v-toolbar-title>Account Questions<span v-if="accountName.length"> - {{ accountName }}</span></v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="question of questionsAccount" :key="question._id">
              <td>{{ question.question }}</td>
              <td>{{ question.answer }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <v-toolbar-title>Identity Questions<span v-if="identityName.length"> - {{ identityName }}</span></v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="question of questionsIdentity" :key="question._id">
              <td>{{ question.question }}</td>
              <td>{{ question.answer }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>

export default {
  name: "QuestionsPage",

  data() {
    return {
      questionHeaders: [
        { text: "Question", value: "question" },
        { text: "Answer", value: "answer" }
      ],

      questionsAccount: [],
      questionsIdentity: [],

      pastNames: [],

      accountName: "",
      identityName: "",
    }
  },

  computed: {

  },

  created() {
    this.loadQuestions();
  },

  methods: {
    loadQuestions() {
      this.$axios.get(`/api/accounts/${this.$route.query.accountId}/questions`).then(res => {
        const data = res.data;

        // ! update title
        document.title = `Questions - ${data.account_name} | ${data.identity_name}`;

        this.pastNames = data.past_names || [];

        this.accountName = data.account_name;
        this.identityName = data.identity_name;

        this.questionsAccount = data.account_questions;
        this.questionsIdentity = data.identity_questions;
      }).catch(err => {
        console.error(err);
      })
    }
  }
}
</script>

<style scoped>

</style>
